<template>
  <div class="section">
    <div class="inquiry-wrap">
      <div class="tit-box">
        <div class="section-tit">1:1 문의내역</div>
        <RouterLink to="/inquiry" class="btn-inquiry">1:1 문의하기</RouterLink>
      </div>

      <div class="inquiry-top">
        <div class="text">{{ selectedYear }}년 {{ selectedMonth }}월 문의내역</div>
        <div class="select">
          <div class="select-wrap">
            <select v-model="selectedYear" class="input-form">
              <option v-for="year in yearOptions" :key="year" :value="year">
                {{ year }}
              </option>
            </select>
          </div>
          <div class="select-wrap">
            <select v-model="selectedMonth" class="input-form">
              <option v-for="(month, idx) in monthOptions" :key="idx" :value="idx + 1">
                {{ month }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div v-if="inquiries.length > 0" class="inquiry-list">
        <div
          v-for="(item, idx) in inquiries"
          :key="idx"
          class="inquiry-item"
          @click="goToDetail(item)"
        >
          <div class="inquiry-title">{{ item.title }}</div>
          <div class="inquiry-date">{{ item.u_datetime?.split(' ')[0] }}</div>
          <div
            class="inquiry-status"
            :class="{
              waiting: item.status === 2,
              done: item.status != 2,
            }"
          >
            {{ item.status == 2 ? '답변 대기중' : '답변 완료' }}
          </div>
        </div>
      </div>
      <div v-else class="data-none">문의 내역이 없습니다.</div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, onBeforeUnmount } from 'vue';
import axios from 'axios';
import { useRouter } from 'vue-router';
import api from '@/utils/api.js';
import { _setStorageWithExpiry, _getStorageWithExpiry, _safeAtob } from '../utils/common.js';
import Footer from '@/components/Footer.vue';

const inquiries = ref([]);
const router = useRouter();
const currentYear = new Date().getFullYear();
const yearOptions = Array.from({ length: 7 }, (_, i) => currentYear - i);
const monthOptions = Array.from({ length: 12 }, (_, i) => {
  const month = i + 1;
  return `${String(month).padStart(2, '0')}`;
});
const selectedYear = ref(currentYear);
const selectedMonth = ref(new Date().getMonth() + 1);
const idntCode = ref('');

watch(idntCode, newVal => {
  // idntCode가 변경되면 postData 호출
  if (newVal) {
    postData();
  }
});

onMounted(() => {
  window.addEventListener('message', handleMessage);
  setTimeout(() => {
    if (!idntCode.value) {
      const stored = _safeAtob(_getStorageWithExpiry('id'));
      idntCode.value = stored;
    }
  }, 500);
});

onBeforeUnmount(() => {
  window.removeEventListener('message', handleMessage);
});

function handleMessage(event) {
  if (event.origin !== 'https://tble.kr') return;
  const { type, id } = event.data;
  if (type === 'inquiryList') {
    _setStorageWithExpiry('id', id);
    idntCode.value = id;
  }
}

watch([selectedYear, selectedMonth], () => {
  postData();
});

function goToDetail(item) {
  router.push({
    path: '/inquiryDetail',
    state: {
      idx: item.idx,
    },
  });
}

async function postData() {
  if (!idntCode.value) {
    return;
  }
  try {
    const response = await api.post('/order.php', {
      mode: 'requestList',
      year: selectedYear.value,
      month: selectedMonth.value,
      idnt_code: idntCode.value,
      type: '99',
    });
    if (response.data) {
      inquiries.value = response.data.data;
    } else {
      console.error('API 응답에 결과가 없습니다.');
    }
  } catch (error) {
    console.error('에러 발생:', error);
  }
}
</script>
